export default "__VITE_ASSET__hZBa2YaY__"